/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./authorize-form.vue?vue&type=template&id=4cc4f966&scoped=true&"
import script from "./authorize-form.vue?vue&type=script&lang=js&"
export * from "./authorize-form.vue?vue&type=script&lang=js&"
import style0 from "./authorize-form.vue?vue&type=style&index=0&id=4cc4f966&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cc4f966",
  null
  
)

export default component.exports